import styled from 'styled-components';

import { Menu } from '@cognite/cogs-core-v11/components/menu/menu.tsx';

export const StyledMenu = styled(Menu)`
  border-radius: unset !important;
  min-width: 250px !important;
  border-right: 1px solid ${({ theme }) => theme['border--muted']} !important;
  box-shadow: unset !important;
`;
